import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Router } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import './App.css';
import { CssBaseline } from '@mui/material';
import {
  Main,
  Menu,
  Cart,
  Order,
  LiteOrder,
  Payment,
  OrderComplete,
  OrderDetail,
  UserOrderStores,
  UserGuide,
  Terms,
  Privacy,
  ServiceUnavailable,
  Join,
} from './components';
import i18n from 'i18next';
import history from './History';
import Snackbar from './components/common/CustomSnackbar';
import ScrollToTop from './ScrollToTop';
import PaymentError from './components/errors/PaymentError';
import Preparing from './components/errors/Preparing';
import QrOrder from './components/qr-order/QrOrder';
import Notation from './components/policy/Notation';
import ConfirmDialog from './components/common/ConfirmDialog';
import liff from '@line/liff';
import api from './api';

@inject('commonStore', 'menuStore', 'cartStore')
@observer
class App extends Component {
  async componentDidMount() {
    // 라인 Liff로 접속한 경우 Liff 초기화가 되어야 엔드포인트 URL로 리다이렉트 되기 때문에 초기화 진행
    if (liff.isInClient()) {
      // 매장 정보를 가져오기 위한 pathname 조회
      let pathname = window.location.pathname;

      // 엔드포인트로 리다이렉트 되기 전인 경우 liff.state를 사용하여 pathname을 조회
      const queryParams = new URLSearchParams(window.location.search);
      let liffState = queryParams.get('liff.state');
      if (liffState) {
        if (liffState.indexOf('?') > -1) {
          liffState = liffState.split('?')[0];
        }
        pathname = liffState;
      }

      // pathname에서 조회한 매장 정보를 가져와 Liff 아이디 조회
      const companyId = pathname.split('/')[1];
      const storeCode = pathname.split('/')[2];
      const result = await api.getLiffId(companyId, storeCode);

      if (!result.data) throw new Error(i18n.t('common.error.occurred'));

      // Liff 초기화
      liff.init({ liffId: result.data });
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
    document.head.appendChild(script);

    const script2 = document.createElement('script');
    script2.src = `//dapi.kakao.com/v2/maps/sdk.js?appkey=${process.env.REACT_APP_KAKAO_MAP_KEY}&libraries=services&autoload=false`;
    script2.async = true;
    document.body.appendChild(script2);

    /* global kakao */
    script2.onload = () => {
      kakao.maps.load();
    };
  }

  render() {
    if (this.props.commonStore.error) {
      throw new Error(this.props.commonStore.error);
    }

    return (
      <React.Fragment>
        <CssBaseline />
        <Router history={history}>
          <ScrollToTop>
            <Switch>
              <Route
                exact
                path="/"
                render={() => {
                  return '';
                }}
              />
              {/* <Route exact path="/" component={Main} /> */}
              <Route exact path="/:companyId/:storeCode/menu-groups/:groupCode/menus/:itemCode" component={Menu} />
              <Route exact path="/:companyId/:storeCode/menus/:itemCode" component={Menu} />
              <Route exact path="/:companyId/:storeCode/cart" component={Cart} />
              <Route exact path="/:companyId/:storeCode/order" component={Order} />
              <Route exact path="/:companyId/:storeCode/lite-order" component={LiteOrder} />
              <Route exact path="/:companyId/:storeCode/lite-orders/:orderId/complete" component={OrderComplete} />
              <Route exact path="/:companyId/:storeCode/lite-orders/:orderId" component={OrderDetail} />
              <Route exact path="/:companyId/:storeCode/join" component={Join} />
              <Route exact path="/:companyId/:storeCode/payment" component={Payment} />
              {/* 나이스페이 주문완료 */}
              <Route exact path="/:companyId/:storeCode/orders/:orderId/complete" component={OrderComplete} />
              {/* 소프트뱅크페이 주문완료 */}
              <Route exact path="/:companyId/:storeCode/order-complete" component={OrderComplete} />
              <Route exact path="/:companyId/:storeCode/orders/:orderId" component={OrderDetail} />
              <Route exact path="/:companyId/:storeCode/errors/payment" component={PaymentError} />
              <Route exact path="/errors/payment" component={PaymentError} />
              <Route exact path="/:companyId/:storeCode/errors/preparing" component={Preparing} />
              <Route exact path="/:companyId/:storeCode/user-guide" component={UserGuide} />
              <Route exact path="/users/:encryptedId/order-stores" component={UserOrderStores} />
              <Route exact path="/terms" component={Terms} />
              <Route exact path="/privacy" component={Privacy} />
              <Route exact path="/:companyId/:storeCode/notation" component={Notation} />
              <Route exact path="/service-unavailable" component={ServiceUnavailable} />
              <Route exact path="/qr-order/:id" component={QrOrder} />
              <Route exact path="/:companyId/:storeCode" component={Main} />
              <Route
                render={() => {
                  throw new Error(i18n.t('common.error.pageNotFound'));
                }}
              />
            </Switch>
            {/** 공통 컴포넌트 */}
            <Snackbar />
          </ScrollToTop>
        </Router>

        <ConfirmDialog />
      </React.Fragment>
    );
  }
}

export default App;
